<template>
        <div id='pointshistory'>
              <NavTop title='历史积分明细' :islink="true" linkurl="/"/>
              <div class='content'>
                    <div class="row">
                       <div class="col-title">日期</div>
                       <div class="col-title">商业公司</div>
                       <div class="col-title">医院</div>
                       <div class="col-title">配送点</div>
                       <div class="col-title">药名</div>
                       <div class="col-title">规格</div>
                       <div class="col-title">佣金率</div>
                       <div class="col-title">数量</div>
                       <div class="col-title">奖励</div>
                    </div>
                    <div class="row" v-for="item in list" :key="item.id">
                       <div class="col">{{item.datetime}}</div>
                       <div class="col">{{item.drugsalecorp}}</div>
                       <div class="col">{{item.drughospital}}</div>
                       <div class="col">{{item.drugterminal}}</div>
                       <div class="col">{{item.mydrugname}}</div>
                       <div class="col">{{item.mydrugspec}}</div>
                       <div class="col">{{item.commission}}</div>
                       <div class="col">{{item.nums}}</div>
                       <div class="col">{{item.points}}</div>
                    </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import {Button,Field,Picker,Popup } from "vant";
export default {
  data(){
      return{
         list:{},
        
      }
  },  
  name: 'pointshistory',
  created(){
     this.getList()
  },
  components:{
    NavTop,
    [Button.name]:Button,
    [Field.name]:Field,
    [Picker.name]:Picker,
    [Popup.name]:Popup
  },
  methods:{
    
     getList(){
        if(this.$route.params.startDate==""||this.$route.params.endDate==""){
             this.$toast("页面参数有误，请稍后再试")
             return false
        } 
        let drugid=this.$route.params.drugid
        let hosname=this.$route.params.hosname

        this.$post("/index/getPointsHistory",{startDate:this.$route.params.startDate,endDate:this.$route.params.endDate,drugid:drugid,drughostpital:hosname}).then((data)=>{
               if(data.result.success){
                  this.list=data.result.info.list;
               }else{
                  this.$toast(data.result.info)
               }
         })   
     }
  }
}
</script>
<style scoped>
#pointsdetail{background-color:#F6F6F6;min-height: 100vh;padding: 0.2rem;}
.content{background-color: #fff;border-radius: 0.2rem;padding: 0.1rem 0.1rem;}
.row{display: flex;flex-flow: row nowrap;border-bottom: 1px dashed #eee;padding: 0.1rem;align-items: center;}
.col-title{font-size:0.38rem;flex:1;}
.col{font-size:0.35rem;flex:1;}
</style>


